export default __webpack_public_path__ + "static/tests-5afb3a971658feb7db59d82f67829982.png";